/**
 * @fileoverview Footer buttons for AssignProjectModal
 */
import type { FC } from 'react'
import { useArcTranslation } from 'hooks'
import { Group, Button, Divider } from 'components'
import { getButtonStyles, SPACING } from './styles'

interface ModalFooterProps {
  isMobile: boolean
  modalPadding: number
  isFormValid: boolean
  isLoading: boolean
  onCancel: () => void
  onSave: () => void
}

export const ModalFooter: FC<ModalFooterProps> = ({
  isMobile,
  modalPadding,
  isFormValid,
  isLoading,
  onCancel,
  onSave,
}) => {
  const { t } = useArcTranslation()
  const buttonStyles = getButtonStyles(isMobile)

  return (
    <>
      <Divider color="#f0f0f0" />
      <Group
        position={isMobile ? 'apart' : 'right'}
        px={modalPadding}
        py={SPACING.element}
        grow={isMobile}
        spacing={SPACING.small}
      >
        <Button
          variant="default"
          onClick={onCancel}
          radius="xl"
          size="md"
          fullWidth={isMobile}
          styles={buttonStyles.cancel}
        >
          {t('general_buttons_cancel')}
        </Button>
        <Button
          onClick={onSave}
          disabled={!isFormValid || isLoading}
          loading={isLoading}
          radius="xl"
          size="md"
          fullWidth={isMobile}
          styles={buttonStyles.save}
        >
          {t('general_buttons_save')}
        </Button>
      </Group>
    </>
  )
}
